var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.56 116.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f333d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.35,97.87c-13,0-26-.06-39,0-4.1,0-7.81-.59-9.67-4.64C-1,89.4.66,85.9,3.49,83.41c7.79-6.86,9.31-15.66,8.83-25.33C11.66,44.88,14.6,33,25.17,24a13.24,13.24,0,0,1,1.55-1.25c5.37-3.27,10.51-5.92,10.76-14C37.66,2.94,44.07-.36,49.71,0S60.54,4.61,60.8,10.89c.23,5.37,2.63,7.88,7.06,9.87,11.5,5.18,16.22,15.14,17.93,26.85a72.62,72.62,0,0,1,.37,13c-.27,8,1.81,15.08,7.51,20.93a29.2,29.2,0,0,1,3.18,3.84c1.81,2.63,2.34,5.43.83,8.45s-4.12,4.1-7.38,4.1Q69.83,97.84,49.35,97.87Zm-.54-83c1.53-.28,4,1,3.82-2.18C52.5,10.46,51.4,9,49,8.88c-2.69-.15-3.31,1.66-3.54,3.77C45.12,15.51,47.37,14.57,48.81,14.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.25,102.92c3.82,0,7.64.14,11.45,0,3-.14,3.31,1,2.52,3.54A15,15,0,0,1,49,116.87C43,117,36.36,112,34.63,106.39c-.78-2.57-.24-3.66,2.66-3.52C41.27,103.06,45.26,102.91,49.25,102.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificari);
export default __webpack_public_path__ + "static/media/IconNotificari.9429076e96a39ca994ae73aa0b2212cc.svg";
export { ForwardRef as ReactComponent };